import { useState } from "react";
import { useLenis } from "lenis/react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, SALON } from "@/data/salon";

const Navbar = () => {
    const [open, setOpen] = useState(false);
    const lenis = useLenis();

    const go = (e, href) => {
        e.preventDefault();
        setOpen(false);
        lenis?.scrollTo(href, { offset: -70, duration: 1.4 });
    };

    return (
        <header
            data-testid="navbar"
            className="fixed top-0 inset-x-0 z-40 bg-cream/85 backdrop-blur-xl border-b border-linen/50"
        >
            <div className="max-w-[1440px] mx-auto px-5 md:px-10 h-[70px] flex items-center justify-between">
                <a
                    href="#top"
                    onClick={(e) => go(e, "#top")}
                    data-testid="navbar-logo"
                    className="flex items-baseline gap-2 group"
                >
                    <span className="font-serif italic text-2xl md:text-[1.7rem] leading-none text-ink group-hover:text-rosegold transition-colors duration-300">
                        Moovie
                    </span>
                    <span className="text-[0.6rem] tracking-[0.35em] uppercase text-stone2">
                        Parrucchieri
                    </span>
                </a>

                <nav className="hidden lg:flex items-center gap-8">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={(e) => go(e, l.href)}
                            data-testid={`nav-link-${l.href.slice(1)}`}
                            className="text-[0.8rem] tracking-[0.12em] uppercase text-stone2 hover:text-ink transition-colors duration-300"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href={SALON.phoneHref}
                        data-testid="nav-cta-button"
                        className="ml-2 inline-flex items-center gap-2 bg-ink text-cream text-[0.8rem] tracking-[0.12em] uppercase px-6 py-3 rounded-full hover:bg-sage transition-colors duration-300"
                    >
                        Prenota
                    </a>
                </nav>

                <button
                    data-testid="mobile-menu-button"
                    onClick={() => setOpen(!open)}
                    aria-label="Menu"
                    className="lg:hidden text-ink p-2"
                >
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            <AnimatePresence>
                {open && (
                    <motion.nav
                        data-testid="mobile-menu"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        className="lg:hidden overflow-hidden border-t border-linen/50 bg-cream/95 backdrop-blur-xl"
                    >
                        <div className="px-6 py-6 flex flex-col gap-5">
                            {NAV_LINKS.map((l) => (
                                <a
                                    key={l.href}
                                    href={l.href}
                                    onClick={(e) => go(e, l.href)}
                                    data-testid={`mobile-nav-link-${l.href.slice(1)}`}
                                    className="font-serif text-2xl text-ink"
                                >
                                    {l.label}
                                </a>
                            ))}
                            <a
                                href={SALON.phoneHref}
                                data-testid="mobile-nav-cta-button"
                                className="mt-2 inline-flex justify-center bg-ink text-cream text-sm tracking-[0.12em] uppercase px-6 py-4 rounded-full"
                            >
                                Chiama e prenota
                            </a>
                        </div>
                    </motion.nav>
                )}
            </AnimatePresence>
        </header>
    );
};

export default Navbar;
